import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_TRANSLATIONS, res.data)
  })
)

export const getGroups = async ({ commit }) => {
  await services.groups().then(res => {
    commit(types.SET_GROUPS, res.data.data)
  })
}

export const getByGroup = async ({ commit }, { languageId, group }) => {
  const res = await services.byGroup(languageId, group)
  return res.data
}

export const save = async ({ commit }, obj) => {
  const res = await services.save(obj)
  commit(types.SET_TRANSLATION, res.data.data)
  return res
}

export const bulkUpdate = async ({ commit }, obj) => {
  const res = await services.bulkUpdate(obj)
  return res
}

export const importTranslations = async ({ commit }, obj) => {
  const res = await services.importTranslations(obj)
  return res
}

export const exportTranslations = async ({ commit }, { languageId, group }) => {
  const res = await services.exportTranslations(languageId, group)
  return res
}

export const copyTranslations = async ({ commit }, obj) => {
  const res = await services.copyTranslations(obj)
  return res
}

export const deleteTranslation = async ({ commit }, id) => {
  const res = await services.deleteTranslation(id)
  return res
}
